/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_RankInputs */

const en_sort_rank = /** @type {(inputs: Sort_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const de_sort_rank = /** @type {(inputs: Sort_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell`)
};

/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Sort_RankInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_rank = /** @type {((inputs?: Sort_RankInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_RankInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_rank(inputs)
	return en_sort_rank(inputs)
});